'use strict';

import Loader from '../../../_modules/loader/loader';
import { isFieldEmpty, isDecimal, displayErrors, isValidEmail } from './_helper';
import OrderOverride from '../../../_modules/order-override/order-override';
import ProductDetails from '../../../_modules/product-details/product-details';
import { toaster } from './_material';
import { invalid } from 'moment';

let $inputFee = $('#UpdatedDeliveryFee'),
    $body = $('body'),
    $orderId = $('#OrderId'),
    $cancellationReason = $('#CancellationReason'),
    $cancellationReasonOther = $('#CancellationReasonOther'),
    $reinstateReason = $("#ReinstateReason"),
    $reinstateReasonOther = $("#ReinstateReasonOther"),
    $overrideWarehouse = $('#OverrideWarehouse'),
    $emailLog1 = $("#CallLog1EmailAddress"),
    $emailLog2 = $("#CallLog2EmailAddress"),
    $emailReason1 = $("#CallLog1EmailReason"),
    $emailReason2 = $("#CallLog2EmailReason"),
    $inputLog1 = $("#callLog1"),
    $inputLog2 = $("#callLog2"),
    loader;

if ($('.view-order').length) {
    let productDetails = new ProductDetails();
    productDetails.init();
}

// Put Loader in a variable
loader = new Loader();

$inputFee.on('blur', function(){
    let fee = $inputFee.val(),
        $total = $('.total-fee');

    $total.text(fee);
});

//if cancellation reason is changed to other show textbox
$cancellationReason.on("change", function(){
    let $this = $(this);
    if($this.val() == "Other") {
        $cancellationReasonOther.removeClass("hidden");
        $cancellationReasonOther.prop("required", true);
    } else {
        $cancellationReasonOther.addClass("hidden");
        $cancellationReasonOther.prop("required", false);
    }
});


//if reinstate reason is changed to other show textbox
$reinstateReason.on("change", function(){
    let $this = $(this);
    if($this.val() == "Other") {
        $reinstateReasonOther.removeClass("hidden");
        $reinstateReasonOther.prop("required", true);
    } else {
        $reinstateReasonOther.addClass("hidden");
        $reinstateReasonOther.prop("required", false);
    }
});

//handle call log email updates to hide email not supplied reason fields
let fnEmailPopulated = function(e){
    let $input = $(this);
    let $parent = $input.parents(".form-input").parent();
    let $reason = $parent.next();

    $input.parent()
            .removeClass("incomplete")
            .find('.error').css({"display": "none"});

    $reason.prop("required", true);
    $reason.removeClass("hidden");

    if($input.val() != ""){
        if(isValidEmail($input.val())) {
            $reason.prop("required", false);
            $reason.addClass("hidden");
            $reason.val("");
        } else {
            $input.parent()
                .addClass("incomplete")
                .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
        }
    }
}

$emailLog1.on("change", fnEmailPopulated);
$emailLog2.on("change", fnEmailPopulated);

$inputLog1.on("change", function(e){
    if($(this).prop("checked")) {
        $(".call1panel").removeClass("hidden");
    } else {
        $(".call1panel").addClass("hidden");
    }
});

$inputLog2.on("change", function(e){
    if($(this).prop("checked")) {
        $(".call2panel").removeClass("hidden");
    } else {
        $(".call2panel").addClass("hidden");
    }
});

// Cancel Order
$('.js-cancel-order').on('click', function (e){
    e.preventDefault();

    let $this = $(this),
        inputId = $this.data('input'),
        $input = $('#' + inputId),
        propertyName = $this.data('property'),
        token = $this.parent().find('input[name=__RequestVerificationToken]').val(),
        apiUrl = $this.data('api'),
        dataParams = {};

    let $errorContainer = $this.parent().parent().siblings('.server-errors__wrap');

    // Define Obj as property name chanes according to input
    dataParams.OrderId = $orderId.val();
    dataParams.CancellationReason = $input.val();
    if(dataParams.CancellationReason == "Other") {
        dataParams.CancellationReason = $cancellationReasonOther.val();
    }

    if(dataParams.CancellationReason == ""){
        toaster('Please provide a reason.', 'error');
        return;
    }

    loader.fadeIn();

    $.ajax({
        url: apiUrl,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'PUT',
        headers: { __RequestVerificationToken: token },
        data: JSON.stringify(dataParams),
        success: function (data) {
            toaster('Order has been cancelled!');
            loader.fadeOut();

            $errorContainer.slideUp({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            window.location.href = data.href;
        },
        error: function (error) {
            loader.fadeOut();
            displayErrors(error, $errorContainer );
        }
    });
});

//override stock check
$('.js-order-override-stock-check').on('click', function (e){
    e.preventDefault();

    let $this = $(this),
        token = $this.parent().find('input[name=__RequestVerificationToken]').val(),
        apiUrl = $this.data('api'),
        dataParams = {};

    let $errorContainer = $this.parent().parent().siblings('.server-errors__wrap');

    // Define Obj as property name chanes according to input
    dataParams.OrderId = $orderId.val();
    dataParams.WarehouseOverride  = $overrideWarehouse.val();
    
    if(dataParams.WarehouseOverride == ""){
        toaster('Please select a warehouse.', 'error');
        return;
    }

    loader.fadeIn();

    $.ajax({
        url: apiUrl,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'PUT',
        headers: { __RequestVerificationToken: token },
        data: JSON.stringify(dataParams),
        success: function (data) {
            toaster('Stock warehouse override has been applied applied!');
            loader.fadeOut();

            $errorContainer.slideUp({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            window.location.href = data.href;
        },
        error: function (error) {
            loader.fadeOut();
            displayErrors(error, $errorContainer );
        }
    });
});

$('.js-agree-reinstate-order').on('click', function (e){
    e.preventDefault();

    let $this = $(this),
        token = $this.parent().find('input[name=__RequestVerificationToken]').val(),
        apiUrl = $this.data('api'),
        $selectReason = $("#ReinstateReason"),
        $txtReason = $("#ReinstateReasonOther"),
        dataParams = {};

    let $errorContainer = $this.parent().parent().siblings('.server-errors__wrap')

    // Define Obj as property name changes according to input
    dataParams.OrderId = $orderId.val();
    dataParams.ReinstateReason = $selectReason.val() == "Other" ? $txtReason.val() : $selectReason.val();

    if(dataParams.ReinstateReason == "") {
        toaster('Please provide a reason.', 'error');
        return;
    }
    
    loader.fadeIn();

    $.ajax({
        url: apiUrl,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'PUT',
        headers: { __RequestVerificationToken: token },
        data: JSON.stringify(dataParams),
        success: function (data) {
            toaster( 'Order has been reinstated!');
            loader.fadeOut();

            $errorContainer.slideUp({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            window.location.href = data.href;
        },
        error: function (error) {
            loader.fadeOut();
            displayErrors(error, $errorContainer );
        }
    });
});

$('.js-agree-cancel-order').on('click', function (e){
    e.preventDefault();

    let $this = $(this),
        inputId = $this.data('input'),
        $input = $('#' + inputId),
        $inputOther = $('#CancellationReasonOther'),
        propertyName = $this.data('property'),
        token = $this.parent().find('input[name=__RequestVerificationToken]').val(),
        apiUrl = $this.data('api'),
        dataParams = {};

    let $errorContainer = $this.parent().parent().siblings('.server-errors__wrap')

    // Define Obj as property name changes according to input
    dataParams.OrderId = $orderId.val();
    dataParams[propertyName] = $input.val();
    if(dataParams[propertyName] == "Other") {
        dataParams[propertyName] = $inputOther.val();
    }

    if(dataParams[propertyName] == "") {
        toaster('Please provide a reason.', 'error');
        return;
    }

    loader.fadeIn();

    $.ajax({
        url: apiUrl,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'PUT',
        headers: { __RequestVerificationToken: token },
        data: JSON.stringify(dataParams),
        success: function (data) {
            toaster( 'Order has been cancelled!');
            loader.fadeOut();

            $errorContainer.slideUp({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            window.location.href = data.href;
        },
        error: function (error) {
            loader.fadeOut();
            displayErrors(error, $errorContainer );
        }
    });
});

$('.call-log-switches .switch__input').on("change", function(e){
    e.preventDefault();

    let $this = $(this),
        token = $this.parents(".call-log-switches").find('input[name=__RequestVerificationToken]').val(),
        apiUrl = "/api/orders/calllog",
        dataParams = [];

    let $errorContainer = $this.parent().parent().siblings('.server-errors__wrap')

    loader.fadeIn();

    var $inputLog1 = $("#callLog1"),
        $inputLog2 = $("#callLog2");

    dataParams.push({
        Id: $inputLog1.data("logid"),
        Checked: $inputLog1.prop("checked"),
        OrderId: $orderId.val()
    });
    dataParams.push({
        Id: $inputLog2.data("logid"),
        Checked: $inputLog2.prop("checked"),
        OrderId: $orderId.val()
    });

    $.ajax({
        url: apiUrl,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'PUT',
        headers: { __RequestVerificationToken: token },
        data: JSON.stringify(dataParams),
        success: function (data) {
            toaster( 'Call log has been saved!');
            loader.fadeOut();

            $errorContainer.slideUp({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            window.location.href = data.href;
        },
        error: function (xhr, statusText, errorMessage) {
            loader.fadeOut();
            toaster( 'Failed to save call log: '+ errorMessage);
        }
    });
});

$('.js-order-log-call').on('click', function (e){
    e.preventDefault();

    let $this = $(this),
        token = $this.parent().find('input[name=__RequestVerificationToken]').val(),
        apiUrl = $this.data('api'),
        dataParams = [];

    let $errorContainer = $this.parent().parent().siblings('.server-errors__wrap')
    let $form = $(".form-modal--call-order");
    $form.find(".incomplete").removeClass(".incomplete");
    $form.find(".error").each(function(idx, itm){
        $(itm).slideUp({
            duration: 0,
            easing: 'easeOutExpo',
            queue: false
        });
    });

    let $statusLog1 = $("#CallLogStatus1"),
        $statusLog2 = $("#CallLogStatus2"),
        invalidFields = [];
    if($inputLog1.prop("checked")) {
        if($statusLog1.val() == "") {
            invalidFields.push($statusLog1);
        }
        if($emailLog1.length > 0) {
            var email = $emailLog1.val().trim();
            if(email == "") {
                if($emailReason1.val() == "") {
                    invalidFields.push($emailReason1);
                }
            } else {
                if(!isValidEmail(email)) {
                    invalidFields.push($emailLog1);
                }
            }
        }
    }

    if($inputLog2.length > 0) {
        if($inputLog2.prop("checked")) {
            if($statusLog2.val() == "") {
                invalidFields.push($statusLog2);
            }
            if($emailLog2.length > 0) {
                var email = $emailLog2.val().trim();
                if(email == "") {
                    if($emailReason2.val() == "") {
                        invalidFields.push($emailReason2);
                    }
                } else {
                    if(!isValidEmail(email)) {
                        invalidFields.push($emailLog2);
                    }
                }
            }
        }
    }
    
    if(invalidFields.length > 0){
        invalidFields.forEach((val, idx) => {
            val.parent()
                .addClass("incomplete")
                .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
        });
        toaster('Please ensure all mandatory fields are populated.', 'error');
        return false;
    }

    let status1 = $statusLog1.val(),
        status2 = $statusLog2.val(),
        email1 = $emailReason1.val(),
        email2 = $emailReason2.val();

    dataParams.push({
        Id: $inputLog1.data("logid"),
        Checked: $inputLog1.prop("checked"),
        OrderId: $orderId.val(),
        CallLogStatusId: status1 == "" ? null : status1,
        EmailNotSuppliedReasonId: email1 == "" ? null : email1,
        Email: $emailLog1.val()
    });
    if($inputLog2.length > 0) {
        dataParams.push({
            Id: $inputLog2.data("logid"),
            Checked: $inputLog2.prop("checked"),
            OrderId: $orderId.val(),
            CallLogStatusId: status2 == "" ? null : status2,
            EmailNotSuppliedReasonId: email2 == "" ? null : email2,
            Email: $emailLog2.val()
        }); 
    }

    loader.fadeIn();
    $.ajax({
        url: apiUrl,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'PUT',
        headers: { __RequestVerificationToken: token },
        data: JSON.stringify(dataParams),
        success: function (data) {
            toaster( 'Call log has been saved!');
            loader.fadeOut();

            $errorContainer.slideUp({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            window.location.href = data.href;
        },
        error: function (error) {
            loader.fadeOut();
            displayErrors(error, $errorContainer );
        }
    });
});

// Hold/UnHold Order
$('.js-hold-unhold-order').on('click', function (e){
    e.preventDefault();

    let isMobileDevice = Modernizr.mq('(max-width: 767px)');

    $.fancybox.open('#hold-unhold-order', {
        autoSize: false,
        closeBtn: false,
        fitToView: false,
        height: isMobileDevice == true ? 300 : 200,
        width: isMobileDevice == true ? 250 : 500,
        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
        type: 'inline',
        wrapCSS: 'modal',
        afterShow: function(){
            $('.js-agree-hold-unhold-order').on('click', function (e){
                $.fancybox.close();

                setTimeout(function () {
                    $('#hold-unhold-order__form').submit();
                }, 100);
            });
        }
    });
});

$('.js-enable-stock-check-order').on('click', function (e){
        e.preventDefault();

        let isMobileDevice = Modernizr.mq('(max-width: 767px)');

        $.fancybox.open('#enable-stock-check-order', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            afterShow: function(){
                $('.js-agree-enable-stock-check-order').on('click', function (e){
                    $.fancybox.close();

                    setTimeout(function () {
                        $('#EnableStockCheckOrderForm').submit();
                    }, 100);
                });
            }
        });
    });
    
    
$('.js-disable-stock-check-order').on('click', function (e){
        e.preventDefault();

        let isMobileDevice = Modernizr.mq('(max-width: 767px)');

        $.fancybox.open('#disable-stock-check-order', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            afterShow: function(){
                $('.js-agree-disable-stock-check-order').on('click', function (e){
                    $.fancybox.close();

                    setTimeout(function () {
                        $('#DisableStockCheckOrderForm').submit();
                    }, 100);
                });
            }
        });
    });

// Edit Delivery fees
$('.js-edit-order-delivery').on('click', function (e) {
    e.preventDefault();

    let $editDeliveryModal = $('.form-modal--edit-order-delivery');

    $editDeliveryModal.slideDown({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false,
        complete: function () {
            $body.addClass('fixed');
        }
    });

});

$('.js-update-delivery-fee').on('click', function(e){
    e.preventDefault();

    let $errorContainer = $(this).parent().siblings('.server-errors__wrap'),
        fee = $inputFee.val();

    if( !isFieldEmpty($inputFee) && !isDecimal(fee) ){
        $inputFee
            .parent().addClass('incomplete')
            .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

        $(this).addClass('error');
        return false;

    } else {

        $(this).removeClass('error');
        loader.fadeOut();
    }

    $.ajax({
        url: '/api/orders',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'POST',
        data: JSON.stringify(fee),
        success: function (data) {

            window.location.href = data.href;
        },
        error: function (error) {
            loader.fadeOut();
            displayErrors(error, $errorContainer );
        }
    });
});



let updateOrderProducts = function (){

    let $errorContainer = $('.js-update-order-products').parent().siblings('.server-errors__wrap'),
        $editProductsModal = $('.form-modal--edit-order-products'),
        dataParams = {};

    let productDetails = new ProductDetails();

    loader.fadeIn();

    dataParams = {
        'OrderId' : $('#OrderId').val(),
        'Products': productDetails.getSelectedProducts()[0].Products
    };

    $.ajax({
        url: '/api/orders/updateproducts',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        headers: { __RequestVerificationToken: $editProductsModal.find('input[name=__RequestVerificationToken]').val() },
        type: 'PUT', 
        data: JSON.stringify(dataParams),
        success: function (data) {
            loader.fadeOut();
            window.location.href = data.href;
            toaster('Order has been saved successfully.');

            $errorContainer.slideUp({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

        },
        error: function (error) {
            loader.fadeOut();
            displayErrors(error, $errorContainer ); 

            let overrideOrder = new OrderOverride(); 
            overrideOrder.getCurrentStock();
        }
    });

};


$('.js-update-order-products').on('click', function (e){
        e.preventDefault();

        let isMobileDevice = Modernizr.mq('(max-width: 767px)');

        $.fancybox.open('#update-order-products', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            afterShow: function(){
                $('.js-agree-update-order-products').on('click', function (e){
                    $.fancybox.close();

                    setTimeout(updateOrderProducts, 100);
                });
            }
        });
    });


// Edit Payment Methods
$('#ManualPaymentTaken').on('click', function (e) {
    e.preventDefault();

    let $editDeliveryModal = $('.form-modal--edit-payment-methods');

    $editDeliveryModal.slideDown({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false,
        complete: function () {
            $body.addClass('fixed');
        }
    });

});

$('#PaymentMethods').on('change', function(e){
    e.preventDefault();

    let $amount = $('#ClientPayableAmount'),
        rawAmount = Number($('#RawOrderAmount').val()),
        transactionFee = Number(($('#TransactionFee').val())),
        gst = Number(($('#gst').val())),
        adminFee = Number(($('#AdministrationFee').val())),
        isGstApplied = $('#TransactionFee').data('gst-applicable'),
        isFeeApplied,
        newAmount;

    isFeeApplied = $('#PaymentMethods option:selected').data('apply-transactionfee');

    if(isFeeApplied){
        newAmount =  rawAmount + (rawAmount * transactionFee);

        if(isGstApplied)
            newAmount += newAmount * gst;
    }
    else
        newAmount = rawAmount;
    newAmount += adminFee;

    // display in dollars
    newAmount *= 0.01;

    //round and update value in readonly input
    $amount.val(newAmount.toFixed(2));
});

$('.js-update-payment-methods').on('click', function (e){
    let $errorContainer = $('.form-modal--edit-payment-methods').find('.server-errors__wrap'),
        $method = $('#PaymentMethods'),
        dataParams = {};

    if( isFieldEmpty($method)){
        $method
            .parent().addClass('incomplete')
            .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

        $(this).addClass('error');
        return false;
    }
    else{
        loader.fadeIn();
        $(this).removeClass('error');
    }

    dataParams ={
        "OrderId": $('#OrderId').val(),
        "PaymentType": $method.val()
    }

    $.ajax({
        url: '/api/orders/manualpaymenttaken',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'PUT',
        headers: { __RequestVerificationToken: $('.form-modal--edit-payment-methods').find('input[name=__RequestVerificationToken]').val() },
        data: JSON.stringify(dataParams),
        success: function (data) {

            window.location.href = data.href;
        },
        error: function (error) {
            loader.fadeOut();
            displayErrors(error, $errorContainer );
        }
    });

});


$('.js-regimen-print').on('click', function (e){

    e.preventDefault();

    let $viewRegimen = $('section.view-regimen'),
        $body = $('body'),
        $regimenTable = $('section.view-regimen-table'),
        $sectionToPrint = $('section.patient-details-hidden'),
        $regimenOrderSummary = $('section.view-regimen__order-summary'),
        $header = $('.header'),
        $main = $('#main'),
        $footer = $('.footer'),
        $regimenDetails;

    $regimenDetails = $sectionToPrint.html();

    //hiding sections that don't need to be printed
    $header.hide();
    $main.hide();
    $footer.hide();
    $viewRegimen.hide();
    $regimenTable.hide();
    $regimenOrderSummary.hide();

    $body.append($regimenDetails);
    window.print();

    $('body > div:last-child').remove();
    $header.show();
    $main.show();
    $footer.show();
    $viewRegimen.show();
    $regimenTable.show();
    $regimenOrderSummary.show();

});



// Print Orders
$('.js-order-print').on('click', function (e){

    e.preventDefault();

    let $order = $('.order-details'),
        $body = $('body'),
        $header = $('.header'),
        $main = $('#main'),
        $footer = $('.footer'),
        $productSection = $('.order-details__form.products'),
        $carerDetailsSection = $('.order-details__form.carer-details'),
        $productRows = $('.order-details__form.products .table-layout__row'),
        $originalContent = $body.html(),
        $orderDetails,
        numOfProducts = 0,
        numOfCarers = 0;

    //add logo
    $order.prepend('<img src="/assets/abbott/images/svg/abbott-logo.svg" class="logo--printable">');

    $('.margin-top--80, .margin-top--50, .order-details__form').each(function(i, obj) {
        $(this).addClass('margin-none-top');
        $(this).addClass('margin-none-bottom');
        // console.log('Adding class');
    });

    $productRows.each(function (i, obj) {
        numOfProducts ++;
    });
    $carerDetailsSection.each(function (i, obj) {
       numOfCarers ++;

       console.log(numOfCarers);
    });

    if($carerDetailsSection.length){
        if(numOfCarers === 1){
            $carerDetailsSection.addClass('page-break');
            $carerDetailsSection.addClass('float-none');
            console.log(numOfCarers);
        }else if(numOfCarers > 1){
            $carerDetailsSection.removeClass('margin-none-bottom');
        }
    }else if (numOfProducts < 5){
        $productSection.addClass('page-break');
    }

    $orderDetails = $order.html();

    //hiding sections that don't need to be printed
    $header.hide();
    $main.hide();
    $footer.hide();

    $productSection.removeClass('page-break');
    $carerDetailsSection.removeClass('page-break');
    $carerDetailsSection.removeClass('float-none');

    $body.append($orderDetails);
    window.print();

    $('body > div:last-child').remove();
    $header.show();
    $main.show();
    $footer.show();
    $('.logo--printable').remove();

    $('.margin-top--80, .margin-top--50, .order-details__form').each(function(i, obj) {
        $(this).removeClass('margin-none-top');
        $(this).removeClass('margin-none-bottom');
        console.log('Adding class');
    });
});

$('.js-order-summary-print').on('click', function (e){

    e.preventDefault();

    let $receipt = $('.section.receipt'),
        $body = $('body'),
        $header = $('.header'),
        $main = $('#main'),
        $footer = $('.footer'),
        $receiptDetails,
        currentUrl = window.location.href;

    //remove title for printing
    $receipt.find('h1').hide();

    $receipt.addClass('.ecco');
    $receiptDetails = $receipt.html();

    //hiding sections that don't need to be printed
    $header.hide();
    $main.hide();
    $footer.hide();

    $body.append($receiptDetails);

    // Chrome fix - A fix to what?
    setTimeout(function() {
        window.print();
        window.location.href = currentUrl;
    }, 250);
});
